var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconWbtc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "WBTC")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WBTC",
    transform: "translate(0.130000, 0.380000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#000000",
    cx: 43.7503223,
    cy: 44.2496657,
    r: 43.4925862
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7547122,18.4682399 L69.3384574,20.8844947 C81.288985,33.9532473 81.288985,53.9823169 69.3384574,67.0510695 L71.7547122,69.4673243 C85.0504173,55.0456561 85.0504173,32.8335289 71.7547122,18.4118607 L71.7547122,18.4682399 Z",
    id: "Shape",
    fill: "#5A5564",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.940874,18.6776487 C34.0096266,6.7271211 54.0386962,6.7271211 67.1074488,18.6776487 L69.5237036,16.2613939 C55.1020354,2.96568876 32.8899082,2.96568876 18.4682399,16.2613939 L20.940874,18.6776487 Z",
    id: "Shape-2",
    fill: "#5A5564",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6776487,67.0752321 C6.74184408,54.0100324 6.74184408,33.9980195 18.6776487,20.9328198 L16.2613939,18.516565 C2.96568876,32.9382333 2.96568876,55.1503605 16.2613939,69.5720287 L18.6776487,67.0752321 Z",
    id: "Shape-3",
    fill: "#5A5564",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0752321,69.3062407 C54.0064795,81.2567682 33.9774099,81.2567682 20.9086573,69.3062407 L18.4924025,71.7224954 C32.9140707,85.0182006 55.1261979,85.0182006 69.5478661,71.7224954 L67.0752321,69.3062407 Z",
    id: "Shape-4",
    fill: "#5A5564",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2546207,35.937762 C58.7713698,30.8958437 54.4221112,29.2044654 48.9211044,28.6889977 L48.9211044,21.7462923 L44.668496,21.7462923 L44.668496,28.5601308 C43.5489646,28.5601308 42.4052707,28.5601308 41.2696309,28.5601308 L41.2696309,21.7462923 L37.0492392,21.7462923 L37.0492392,28.7373228 L28.4232097,28.7373228 L28.4232097,33.287936 C28.4232097,33.287936 31.5643409,33.2315567 31.5160158,33.287936 C32.6932237,33.158431 33.7615092,33.9845718 33.9322706,35.1565063 L33.9322706,54.2932442 C33.9078228,54.694978 33.7218967,55.0697353 33.4168029,55.3322338 C33.1173887,55.5997796 32.7217803,55.7335883 32.321434,55.7027262 C32.3778133,55.7510513 29.2286279,55.7027262 29.2286279,55.7027262 L28.4232097,60.7849154 L36.9686974,60.7849154 L36.9686974,67.8887045 L41.2213058,67.8887045 L41.2213058,60.8896198 L44.6201709,60.8896198 L44.6201709,67.8564878 L48.8808335,67.8564878 L48.8808335,60.8332405 C56.0651644,60.3983147 61.074866,58.6263945 61.7030923,51.901152 C62.2105058,46.4887413 59.6653841,44.0724865 55.5980218,43.0979304 C58.0706559,41.8817488 59.6009506,39.6265777 59.2546207,35.937762 Z M53.2945256,51.063517 C53.2945256,56.3470608 44.2416243,55.7429971 41.358227,55.7429971 L41.358227,46.3679285 C44.2416243,46.3759827 53.2945256,45.5464019 53.2945256,51.063517 Z M51.3212509,37.8546575 C51.3212509,42.6871671 43.7664276,42.0992118 41.3662811,42.0992118 L41.3662811,33.5778865 C43.7664276,33.5778865 51.3212509,32.8207934 51.3212509,37.8546575 Z",
    id: "Shape-5",
    fill: "#F09242",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9919447,88 C19.6935133,87.9955503 -0.00148274185,68.2957463 0,43.9973146 C0.00148274185,19.6988829 19.6988829,0.00148274185 43.9973146,0 C68.2957463,-0.00148274185 87.9955503,19.6935133 88,43.9919447 C88.0021353,55.6642612 83.366272,66.8591234 75.1126977,75.1126977 C66.8591234,83.366272 55.6642612,88.0021353 43.9919447,88 Z M43.9919447,3.43106816 C21.6059942,3.44887056 3.47051975,21.605974 3.47940921,43.9919297 C3.48830521,66.3778855 21.6381996,84.5205788 44.0241571,84.5205788 C66.4101147,84.5205788 84.5600158,66.3779004 84.5689199,43.9919447 C84.5731957,33.230432 80.2989935,22.9086892 72.6879437,15.3006609 C65.0768939,7.69263252 54.7534548,3.42252906 43.9919447,3.43106816 Z",
    id: "Shape-6",
    fill: "#282138",
    fillRule: "nonzero"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWbtc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_WBTC.c5e5bc68.svg";
export { ForwardRef as ReactComponent };